import { API_BASE_URL } from "../config";
import React, { useEffect, useState } from "react";
import axios from "axios";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOrders = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/client/allOrders`);
      const ordersData = Array.isArray(res.data) ? res.data : (res.data?.orders || []);
      setOrders(ordersData);
    } catch (err) {
      setError("Error fetching order book");
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
    const interval = setInterval(fetchOrders, 3000);
    return () => clearInterval(interval);
  }, []);

  if (loading) return <div className="orders"><p>Loading order book...</p></div>;
  if (error) return <div className="orders"><p>{error}</p></div>;

  return (
    <div className="orders">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
        <h3 className="title" style={{ margin: 0 }}>Today's Order Book ({orders.length})</h3>
        <button onClick={fetchOrders} style={{ padding: "4px 10px", borderRadius: "4px", border: "1px solid #ccc", backgroundColor: "#fff", cursor: "pointer", fontSize: "12px" }}>
          🔄 Refresh
        </button>
      </div>

      {orders.length === 0 ? (
        <div className="no-orders" style={{ padding: "40px", textAlign: "center", backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #eee" }}>
          <p style={{ color: "#666", fontSize: "15px", fontWeight: 500, margin: 0 }}>No orders placed today.</p>
          <p style={{ fontSize: "13px", color: "#999", marginTop: "6px" }}>
            Orders placed during today's trading session will appear here with live execution status.
          </p>
        </div>
      ) : (
        <div className="order-table" style={{ backgroundColor: "#fff", borderRadius: "8px", overflow: "hidden", border: "1px solid #eee" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#f5f5f5", color: "#555", fontSize: "12px" }}>
                <th style={{ padding: "10px" }}>Time</th>
                <th style={{ padding: "10px" }}>Type</th>
                <th style={{ padding: "10px" }}>Instrument</th>
                <th style={{ padding: "10px" }}>Product</th>
                <th style={{ padding: "10px" }}>Qty</th>
                <th style={{ padding: "10px" }}>Price</th>
                <th style={{ padding: "10px" }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, idx) => (
                <tr key={order._id || idx} style={{ borderBottom: "1px solid #eee", textAlign: "center", fontSize: "13px" }}>
                  <td style={{ padding: "10px", color: "#666", fontSize: "12px" }}>
                    {order.createdAt ? new Date(order.createdAt).toLocaleTimeString() : "-"}
                  </td>
                  <td style={{ padding: "10px", fontWeight: "bold", color: order.mode === "BUY" ? "#4184f3" : "#ef5350" }}>
                    {order.mode}
                  </td>
                  <td style={{ padding: "10px" }}><strong>{order.name}</strong></td>
                  <td style={{ padding: "10px" }}>
                    <span style={{ padding: "2px 6px", borderRadius: "4px", backgroundColor: "#eef6ff", color: "#1976d2", fontWeight: "bold", fontSize: "11px" }}>
                      {order.productType || "MIS"}
                    </span>
                  </td>
                  <td style={{ padding: "10px", fontWeight: "bold" }}>{order.qty}</td>
                  <td style={{ padding: "10px" }}>₹{order.price ? order.price.toFixed(2) : "0.00"}</td>
                  <td style={{ padding: "10px" }}>
                    <span
                      style={{
                        padding: "3px 8px",
                        borderRadius: "12px",
                        fontSize: "11px",
                        fontWeight: "bold",
                        backgroundColor: order.status === "COMPLETE" ? "#e8f5e9" : order.status === "REJECTED" ? "#ffebee" : "#fff8e1",
                        color: order.status === "COMPLETE" ? "#2e7d32" : order.status === "REJECTED" ? "#c62828" : "#f57f17",
                      }}
                    >
                      {order.status || "COMPLETE"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Orders;
